// extracted by mini-css-extract-plugin
module.exports = {"partnerContainer":"BreakoutPartner_partnerContainer__1-5A0","down":"BreakoutPartner_down__3B-3s","heading":"BreakoutPartner_heading__2tl6G"};